// @flow strict

import * as React from 'react';
import classNames from '@ta/common.classnames';
import styles from './LoadingSpinner.css';

type Props = {|
  /** The size of the loader. Options are "small", "large", and leave blank for medium. */
  size?: 'small' | 'large',
  /** The color of the loader's background. Options are "light", "dark", and leave blank for use on white. */
  inverted?: boolean,
|};

/**
 * A progress loader
 */
const LoadingSpinner = ({ size, inverted }: Props) => (
  <div
    className={classNames(styles.spinner, {
      [styles.small]: size === 'small',
      [styles.large]: size === 'large',
      [styles.inverted]: inverted,
    })}
  />
);

LoadingSpinner.defaultProps = {
  size: undefined,
  inverted: false,
};

export default LoadingSpinner;
